module.exports = __webpack_public_path__ + "img/diamond-vein.952c9663.png";